import { Component, ViewChild, Inject, NgZone } from '@angular/core';
import { EServicesBase, CustomTab } from 'Shared/eservices-base/eServices-base';
import { Inquiry } from '../models/inquiry';
import { NgForm } from '@angular/forms';
import { DocumentModel } from 'Shared/Uploader/Models/DocumentModel';
import { GridColumn, ColumnFieldType } from 'Shared/modules/grid/Models/GridColumn';
import { InquiryService } from './inquiry.service';
import { ResourceService } from 'Shared/services/resources-service/resource.service';
import { LookupService } from 'Shared/services/lookup-service/lookup.service';
import { CommonService } from 'Shared/services/common-service/common.service';
import { PopupService } from 'Shared/modules/popup/popup.service';
import { DocumentService } from 'Shared/services/Document-service/document-service';
import { LookupEntity } from 'Shared/models/lookup-entity';
import { LookupType } from 'Shared/enums/lookup-Type.enum';
import { DocumentEntity } from 'Shared/models/document-entity';
import { DocumentConfigurationEnum } from 'Shared/enums/document-configuration.enum';
import { RecaptchaLoaderService } from 'ng-recaptcha';
import { RecaptchaDynamicLanguageLoaderService } from 'Shared/services/Recaptcha/dynamic-language-loader.service';
import { LookupKeyValue } from 'Shared/models/lookup-key-value';
import { Observable, timer } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import { RecaptchaV3Service } from '../../../../Shared/services/Recaptcha/recaptchaV3.service';

@Component({
  selector: 'app-root',
  templateUrl: './inquiry.app.component.html',
  styleUrls: ['./inquiry.app.component.css']
})
export class InquiryComponent extends EServicesBase<Inquiry>{
  @ViewChild('inquiryRequestForm') inquiryRequestForm: NgForm;
  @ViewChild('ViewForm') ViewForm: NgForm;
  showLandingSection: boolean = true;
  isAddForm: boolean = false;
  isViewForm: boolean = false;
  ReferenceNumber: string;
  SecuirtyCode: string;
  birthDateOptions: any = {}
  attachments: DocumentModel[];
  isAttacmentValid: boolean = false;
  gridConfig: GridColumn[]
  showViewError: boolean = false;
  isAttachmentIdVaildReopen: boolean = false;
  attachmentsReopen: DocumentModel[];
  inquiryDetailsText: string;
  isReopen: boolean = false;
  captchaModel?: string;
  isViewSubmitted: boolean;
  isResendEnabled: boolean = true;
  secondsRemaining$: Observable<number>;
  constructor(protected applicationService: InquiryService,
    protected resourceService: ResourceService,
    protected lookupService: LookupService, protected commonService: CommonService,
    protected modalService: PopupService,
    protected documentService: DocumentService,
    @Inject(RecaptchaLoaderService) private loader: RecaptchaDynamicLanguageLoaderService,
    private zone: NgZone, private recaptchaV3Service: RecaptchaV3Service) {
    super(applicationService, resourceService, lookupService, commonService, modalService, documentService)
    this.Application = new Inquiry();
  }
  protected tabs(): CustomTab[] {
    return [{
      tabIndex: 1,
      formName: "inquiryRequestForm",
      form: this.inquiryRequestForm,
      isTabValid: this.validateInquiryRequestForm
    }];
  }
  protected TApplicationNewInstance(): Inquiry {
    return new Inquiry();
  }
  protected getServiceFolder(): string {
    return "InquiryService";
  }
  protected getResourcesFileName(): string {
    return "Resource";
  }
  showAddForm() {
    this.showLandingSection = false;
    this.isAddForm = true;
  }
  showViewForm() {
    this.showLandingSection = false;
    this.isViewForm = true;
  }
  CheckUserIsVaildToViewApplication() {
    this.isViewSubmitted = true;
    if (this.ViewForm.valid) {
      this.showViewError = false;
      this.commonService.showLoader();
      this.applicationService.CheckUserIsVaildToViewApplication(this.SecuirtyCode.trim(), this.ReferenceNumber.trim()).subscribe(result => {
        if (result.IsSucceeded) {
          let requestId = result.Data;
          this.isBack = true;
          window.location.href = window.location.href.toLowerCase().split('/services')[0] + "/services/forms/inquiry?applicationId=" + requestId;
        }
        else {
          this.showViewError = true;
        }
        this.commonService.hideLoader();
      });
    }

  }

  beforeInitForm() {
    this.recaptchaV3Service.loadRecaptchaV3();
    var urlParams = this.commonService.getUrlParams();
    if (this.applicationId) {
      this.isAddForm = true;
      this.showLandingSection = false;
    }
    else if (urlParams["vi"] == "true") {
      this.isViewForm = true;
      this.showLandingSection = false;
    }
  }
  protected extendInitForm(): void {
    const now = Date.now();
    const days = 18 * 365 * 24 * 60 * 60 * 1000;
    this.birthDateOptions.enabledDateRanges = [{ start: new Date(new Date().getFullYear() - 200, new Date().getMonth(), new Date().getDate()), end: new Date(now - 1 * days) }];
    this.birthDateOptions.language = this.resourceService.getCurrentLanguagePrefix();
    this.GridConfig();
  }
  protected getLookupTypes(): LookupEntity[] {
    let lookups: LookupEntity[] = [
      {
        lookupType: LookupType.CRMCountry,
        name: "Country",
        customUrl: ""
      },
      {
        lookupType: LookupType.CRMCaseRegardingInquiry,
        name: "InquirySubject",
        customUrl: ""
      }

    ];
    return lookups;
  }
  protected getDocumentConfigurations(): DocumentEntity[] {
    let documentConfigurations: DocumentEntity[] = [
      {
        name: "Documents",
        documentConfiguration: DocumentConfigurationEnum.Defualt,
        customUrl: "",
      }
    ];
    return documentConfigurations;
  }
  protected afterResourcesLoaded(): void {
    this.loader.updateLanguage(this.resourceService.getCurrentLanguagePrefix());
  }
  validateInquiryRequestForm(self: any): boolean {
    if (self.Application.IsSubmitted) {
      if (self.isAttacmentValid && self.Application.DateOfBirth)
        if (self.isReopen) {
          if (self.isAttachmentIdVaildReopen)
            return true;
          return false;
        }
        else
          return true;
    }
  }
  IsAttachmentIdVaild(event) {
    this.isAttacmentValid = event;
  }
  getFilesId() {
    this.Application.Attachments = new Array<DocumentModel>();
    if (this.attachments != undefined && this.attachments.length > 0) {
      if (this.attachments.length == 1) {
        this.Application.AttachmentId = this.attachments[0].TempId != "" && this.attachments[0].TempId != null ? this.attachments[0].TempId : this.attachments[0].RealId;
      }
      else {
        let list = this.attachments.filter(a => !a.IsDeleted);
        this.Application.AttachmentId = list[0].TempId != "" && list[0].TempId != null ? list[0].TempId : list[0].RealId;
      }
      for (var i = 0; i < this.attachments.length; i++) {
        this.Application.Attachments.push(this.attachments[i]);
      }
    }
  }
  extendHandleRetrievedApplication(application: Inquiry): void {

    if (application.Attachments) {
      if (application.AttachmentId) {
        this.attachments = new Array<DocumentModel>();
        let items = application.Attachments.filter(a => a.RealId == application.AttachmentId);
        if (items.length > 0)
          this.attachments.push(items[0])
      }
    }
    if (!this.commonService.currentUser.IsAnonymous && !this.applicationId) {
      this.Application.Request.RequestorEmail = this.commonService.currentUser.ApplicantEmail;
      this.Application.Request.RequestorEmiratesId = this.commonService.currentUser.EmiratesID;
      this.Application.FirstName = this.commonService.currentUser.FirstName;
      this.Application.LastName = this.commonService.currentUser.LastName;
      this.Application.IsCitizen = this.commonService.currentUser.IsUAECitizen;
      if (!this.commonService.currentUser.IsUAECitizen) {
        if (this.commonService.currentUser.EmiratesID) {
          this.Application.IsResident = true;
        }
        else {
          this.Application.IsResident = false;
        }
      }
      // this.Application.Request.RequestorMobileNumber = this.commonService.currentUser.Mobile;
      this.Application.Request.RequestorName = this.commonService.currentUser.Fullname;
      this.Application.DateOfBirth = this.commonService.currentUser.DateOfBirth;
    }
    if (this.commonService.currentUser.IsAnonymous && this.commonService.currentUser.IsBackEndUser && !this.applicationId)
      this.Application.IsAnonymous = true;
    if (!this.applicationId)
      this.Application.IsParent = true;
    if (application.PreferredCommunication)
      this.Application.PreferredCommunication = parseInt(application.PreferredCommunication.toString());
    //remove duplicate from case regarding
    //this.isFormReadyEventEmitter.subscribe(result => {
    //  let tempRegarding: LookupKeyValue[] = [];
    //  this.lookupService.lookupEntities[this.lookupType.CRMCaseRegardingInquiry].forEach((item, index) => {
    //    if (tempRegarding.findIndex(i => i.Name == item.Name) === -1) {
    //      tempRegarding.push(item)
    //    }

    //  });
    //  this.lookupService.lookupEntities[this.lookupType.CRMCaseRegardingInquiry] = tempRegarding;
    //})
    if (this.Application.InquirySubjectId == "EDAS") {
      this.Application.InquirySubjectId ="1" ;
    }
  }
  protected preSubmitApplication(): void {
    this.Application.PreferredCommunication = 2
    if (this.isReopen) {
      this.Reopen();
    } else {
      this.getFilesId();
      let countries: any = {};
      if (this.Application.IsAnonymous) {
        //if (this.Application.FirstName)
        //  this.Application.FirstName = this.Application.FirstName.trim();
        //if (this.Application.LastName)
        //  this.Application.LastName = this.Application.LastName.trim();
        if (!this.Application.Request.RequestorName || this.Application.Request.RequestorName.trim() == "")
          this.Application.Request.RequestorName = this.Application.FirstName + " " + this.Application.LastName;
      }
      else {
        this.Application.FirstName = this.Application.Request.RequestorName;
      }
      countries = this.lookupService.lookupEntities[LookupType.CRMCountry];
      if (this.Application.IsCitizen)
        this.Application.Request.CountryId = countries.filter(a => a.IsUAE == true)[0].Key;
    }
    if (this.Application.InquirySubjectId == "1") {
      this.Application.InquirySubjectId = "EDAS";
    }
  }
  Reopen() {
    if (!this.Application.ParentInquiryId)
      this.Application.ParentInquiryId = this.Application.Id;
    this.Application.Id = undefined;
    this.Application.Request.Id = undefined;
    this.Application.RequestId = undefined;
    this.Application.ReferenceNumber = undefined;
    this.Application.Action = null;
    this.Application.EmployeeComment = null;
    this.Application.Attachments = new Array<DocumentModel>();
    if (this.attachmentsReopen != undefined && this.attachmentsReopen.length > 0) {
      if (this.attachmentsReopen.length == 1) {
        this.Application.AttachmentId = this.attachmentsReopen[0].TempId != "" && this.attachmentsReopen[0].TempId != null ? this.attachmentsReopen[0].TempId : this.attachmentsReopen[0].RealId;
      }
      else {
        let list = this.attachmentsReopen.filter(a => !a.IsDeleted);
        this.Application.AttachmentId = list[0].TempId != "" && list[0].TempId != null ? list[0].TempId : list[0].RealId;
      }
      for (var i = 0; i < this.attachmentsReopen.length; i++) {
        this.Application.Attachments.push(this.attachmentsReopen[i]);
      }
    }
    else
      this.Application.AttachmentId = undefined;
    this.Application.InquiryDetails = this.inquiryDetailsText;
    if (this.Application.IsParent)
      this.Application.LastChildRequestId = this.applicationId;
  }
  ReopenRequest() {
    this.isReopen = true;
    this.Application.IsReopen = true;
    this.submitForm();
  }
  GridConfig() {
    this.gridConfig = [
      {
        field: 'ReferenceNumber',
        label: 'lbl_ReferenceNumber',
        header: 'lbl_ReferenceNumber',
        typeConfig: {
          type: ColumnFieldType.Href,
          urlKey: "Url"
        }
      },
      {
        field: 'CreatedOn',
        header: "lbl_Createdon",
        label: "lbl_Createdon",
        typeConfig: {
          type: ColumnFieldType.Date,
          dateFormat: "yyyy-MM-dd:HH:MM"
        }
      }]
  }
  backAnonymous() {
    if (!this.commonService.currentUser.IsAnonymous && this.commonService.currentUser.IsBackEndUser)
      this.commonService.backToWorkSpace();
    else {
      this.isBack = true;
      this.modalService.close("genericErrorPopup");
      window.location.href = window.location.href.toLowerCase().split('/services')[0] + "/services/forms/inquiry";
    }
  }
  IsAttachmentIdVaildReopen(event) {
    this.isAttachmentIdVaildReopen = event;
  }
  ResendSecuirtyCode() {
    this.applicationService.ResendSecuirtyCode(this.applicationId).subscribe(result => {
      if (result.IsSucceeded)
        this.modalService.open("resendCodePopup");
      else
        this.modalService.open("resendCodePopupError");
    });
  }
  closePopup() {
    this.modalService.close("resendCodePopup");
    this.modalService.close("resendCodePopupError");
  }


  isValidInformationChange(isvalid: boolean) {
    if (isvalid) {
      this.ResendVertificationCode();
    }
  }

  ResendVertificationCode() {
    if (this.isResendEnabled &&
      this.Application.Request.RequestorEmail &&
      this.Application.Request.RequestorEmail != "")
    {
      this.isResendEnabled = false;
      this.commonService.sendToken(this.Application.Request.RequestorEmail).subscribe(result => {
        var seconds = 60;
        this.secondsRemaining$ = timer(0, 1000).pipe(
          map(n => {
            let remainingSeconds = (seconds - n) * 1000;
            if (remainingSeconds == 0)
              this.isResendEnabled = true;
            return remainingSeconds;
          }),
          takeWhile(n => n >= 0),
        );
      })
    }
  }

  protected onSaveApplicationError() {
    grecaptcha.reset();
    this.Application.ReCaptchaResopnse = null;
  }

  public submitForm(): void {
    this.recaptchaV3Service.getToken().then((token) => {
      this.Application.ReCaptchaResopnse = token;
      super.submitForm();
    });
  }
}
